import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { MiniPIPBase } from './MiniPIPBase';
import { ProductOverview } from './ProductOverview';
import { ProductSpecs } from './ProductSpecs';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from '../../AddToConstants';
import { useIntentProductData } from '../../hooks/useIntentProductData';
import { MiniPIPFull } from './MiniPIPFull';
import { ProductReviews } from './ProductReviews';

export const MiniPipWrapper = ({
  itemId, isSearchResults, isDisplayOnly, hideSalientPoints,
  isIntent = false, handleResolveIntent
}) => {
  const {
    screen, productPodItemData, setSourceScreen,
    setScreen, addToType, setSelectedProductDetails
  } = useContext(AddToContext);

  const { onIntentResolved = null, quantity: intentQty = 1 } = productPodItemData || {};
  const [quantity, setQuantity] = useState(intentQty);
  const {
    MINI_PIP_BASE, MINI_PIP_PRODUCT_OVERVIEW, MINI_PIP_PRODUCT_SPECS,
    MINI_PIP_PRODUCT_REVIEWS, MINI_PIP_FULL, LIST_SELECT_GROUP, DEFAULT
  } = SCREENS;

  const { omsId, sku, product } = useIntentProductData({ itemId, isIntent });

  const onQuantityChange = (item, valueArg) => {
    const quant = valueArg?.quantity;
    setQuantity(quant);
  };

  const handleSubmit = async (__sourceScreen = SCREENS.MINI_PIP_BASE) => {
    if (addToType === 'List') {
      if (onIntentResolved) {
        onIntentResolved({ itemId, quantity });
      } else {
        setSelectedProductDetails({ itemId, quantity, productData: { product } });
        setSourceScreen(__sourceScreen);
        setScreen(LIST_SELECT_GROUP);
      }
    } else {
      if (addToType === 'Project' && isIntent) {
        await handleResolveIntent({
          omsId,
          sku
        });
        return;
      }
      setSelectedProductDetails({ itemId, quantity, productData: product });
      setScreen(DEFAULT);
    }
  };

  return (
    <>
      {screen === MINI_PIP_BASE && (
        <MiniPIPBase
          itemId={itemId}
          isSearchResults={isSearchResults}
          quantity={quantity}
          isDisplayOnly={isDisplayOnly}
          hideSalientPoints={hideSalientPoints}
          onQuantityChange={onQuantityChange}
          onSubmit={handleSubmit}
        />
      )}
      {screen === MINI_PIP_PRODUCT_OVERVIEW && (
        <ProductOverview
          itemId={itemId}
          isDisplayOnly={isDisplayOnly}
          onSubmit={handleSubmit}
        />
      )}
      {screen === MINI_PIP_PRODUCT_SPECS && (
        <ProductSpecs
          itemId={itemId}
          isDisplayOnly={isDisplayOnly}
          onSubmit={handleSubmit}
        />
      )}
      {screen === MINI_PIP_PRODUCT_REVIEWS && (
        <ProductReviews
          itemId={itemId}
          isDisplayOnly={isDisplayOnly}
          onSubmit={handleSubmit}
        />
      )}
      {screen === MINI_PIP_FULL && (
        <MiniPIPFull itemId={itemId} isSearchResults={isSearchResults} />
      )}
    </>
  );
};

MiniPipWrapper.propTypes = {
  itemId: PropTypes.string.isRequired,
  isSearchResults: PropTypes.bool,
  isDisplayOnly: PropTypes.bool,
  hideSalientPoints: PropTypes.bool,
  handleResolveIntent: PropTypes.func,
  isIntent: PropTypes.bool
};

MiniPipWrapper.defaultProps = {
  isSearchResults: false,
  isDisplayOnly: false,
  hideSalientPoints: false,
  handleResolveIntent: null,
  isIntent: false,
};

MiniPipWrapper.dataModel = extend(
  MiniPIPBase,
  ProductOverview,
  ProductSpecs,
  ProductReviews,
  MiniPIPFull
);
